import React from "react";
import Utils from "Utils/utils";
import "./emailStatusBadge.scss";

// The standard email statuses (backend EmailStatuses) → how they're shown.
const STATUS = {
  valid: { label: "Valid", tone: "good" },
  risky: { label: "Risky", tone: "warn" },
  "catch-all": { label: "Catch-all", tone: "warn" },
  unknown: { label: "Unknown", tone: "muted" },
  invalid: { label: "Invalid", tone: "bad" },
  do_not_mail: { label: "Do not mail", tone: "bad" },
  spamtrap: { label: "Spam trap", tone: "bad" },
  abuse: { label: "Abuse", tone: "bad" }
};

// One small icon per tone: a check for good, a dot-in-circle for "can't be sure", a cross for bad.
const ICON = {
  good: (
    <svg viewBox="0 0 16 16" width="14" height="14" aria-hidden="true">
      <circle cx="8" cy="8" r="7" fill="currentColor" />
      <path d="m4.8 8.2 2.1 2.1 4.3-4.4" fill="none" stroke="#fff" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  warn: (
    <svg viewBox="0 0 16 16" width="14" height="14" aria-hidden="true">
      <circle cx="8" cy="8" r="7" fill="currentColor" />
      <path d="M8 4.4v4.3" stroke="#fff" strokeWidth="1.7" strokeLinecap="round" />
      <circle cx="8" cy="11.2" r="1" fill="#fff" />
    </svg>
  ),
  bad: (
    <svg viewBox="0 0 16 16" width="14" height="14" aria-hidden="true">
      <circle cx="8" cy="8" r="7" fill="currentColor" />
      <path d="m5.6 5.6 4.8 4.8M10.4 5.6l-4.8 4.8" stroke="#fff" strokeWidth="1.7" strokeLinecap="round" />
    </svg>
  ),
  muted: (
    <svg viewBox="0 0 16 16" width="14" height="14" aria-hidden="true">
      <circle cx="8" cy="8" r="6.2" fill="none" stroke="currentColor" strokeWidth="1.6" />
      <path d="M6.4 6.3a1.7 1.7 0 1 1 2.3 1.6c-.5.2-.7.5-.7 1v.3" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <circle cx="8" cy="11.3" r=".9" fill="currentColor" />
    </svg>
  )
};

/** The status as a badge meta ({label, tone}), or null when there's nothing to show. */
export const emailStatusMeta = status => STATUS[String(status || "").toLowerCase()] || null;

/**
 * A contact email's verification status (contact.emailVerification: {status, source, checkedTs}),
 * as a small coloured icon placed before the email, with the status name on hover. Renders nothing for an unchecked email.
 */
const EmailStatusBadge = ({ verification, className = "" }) => {
  const status = verification && String(verification.status || "").toLowerCase();
  const meta = emailStatusMeta(status);
  if (!meta || Utils.isSalesIntelHost()) return null;
  return (
    <span className={`emailStatusIcon ${meta.tone} ${className}`} title={meta.label} aria-label={`${meta.label} email`} role="img">
      {ICON[meta.tone]}
    </span>
  );
};

export default EmailStatusBadge;
